import React, { ReactElement } from "react";
import CampaignProductList from "../../components/Campaign/Products";
import Layout from "../../components/layout";

const CampaignProductPage = (): ReactElement => {
  return (
    <Layout>
      <CampaignProductList />
    </Layout>
  );
};

export default CampaignProductPage;
